// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import Author from "types/common/author";
import ReduxStyleguide from "types/redux/styleguide";
// MARK: Components
import { ExternalLink } from "components/common/links/standard";
import Image from "components/common/media/image";
import Typography from "components/common/typography";
// MARK: Utils
import renderDate from "utils/common/formattedDate";
import CSSStyles from "enums/cssStyles";

interface AuthorContainerProps {
    marginTop: number;
  }
  
  const AuthorContainer = styled.div<AuthorContainerProps>`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-top: ${({ marginTop }) => marginTop + "px"};
  `;
  
  const AuthorImageContainer = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 30px;
    overflow: hidden;
  `;

  interface BlogPostAuthorProps {
    author: Author;
    dateCreated: string;
    dateUpdated: string;
  }

  const BlogPostAuthor = ({ author, dateCreated, dateUpdated } : BlogPostAuthorProps) => {

    // Mark: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );

  const { margin, colors } = styleguide

    return (<ExternalLink href={author.linkedinUrl}>
    <AuthorContainer marginTop={margin}>
      <AuthorImageContainer>
        <Image src={author.headshot[0].url} alt={author.name} />
      </AuthorImageContainer>
      <Typography
        marginLeft={margin}
        className={CSSStyles.navigation}
        color={colors.primary}
      >
        Written by {author.name}
        <br />
        First published on {renderDate(dateCreated)}
        <br />
        Last Updated on {renderDate(dateUpdated)}
      </Typography>
    </AuthorContainer>
  </ExternalLink>)
  }

  export default BlogPostAuthor